import * as TabsPrimitive from "@radix-ui/react-tabs"
import { motion } from "framer-motion"
import { Icon } from '@iconify/react'

export default function AnimatedTabs({ tabs, setActiveTab, activeTab, className, singleTabCssClass }) {

    return (
        <TabsPrimitive.Root
            value={activeTab}
            onValueChange={setActiveTab}
            className={`${className} w-full`}
        >
            <TabsPrimitive.List className="flex border-gray-200">
                {tabs.map((tab) => (
                    <TabsPrimitive.Trigger
                        key={tab.id}
                        value={tab}
                        className={`${
                            activeTab?.id === tab.id
                                ? "text-primary"
                                : "text-gray-500 hover:text-gray-700"
                        } relative px-4 py-2 text-sm font-medium transition-colors duration-200 ${singleTabCssClass} flex items-center justify-center gap-1`}
                    >
                        {tab.icon ? <Icon icon={tab.icon} /> : null}
                        {tab.title}
                        {activeTab?.id === tab.id && (
                            <motion.div
                                className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary"
                                layoutId="activeTab"
                                transition={{ type: "spring", stiffness: 300, damping: 30 }}
                            />
                        )}
                    </TabsPrimitive.Trigger>
                ))}
            </TabsPrimitive.List>

        </TabsPrimitive.Root>
    )
}